<template>
  <div class="order-list-page">
    <div class="page-header">
      <span class="page-title">特困供养人员护理</span>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">筛选查询</span>
      </div>
      <el-form :inline="true" ref="search" :model="search" class="mt15">
        <el-form-item prop="rangeDate">
          <el-date-picker
            v-model="search.rangeDate"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            clearable
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="region">
          <el-select v-model="search.region" placeholder="城市" @change="regionBlurFn" clearable>
            <el-option v-for="region in regionList" :label="region" :value="region" :key="region"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="hospital_name">
          <el-select v-model="search.hospital_name" allow-create filterable default-first-option placeholder="医院" clearable>
            <el-option
              v-for="hospital_name in hospitalColumns"
              :label="hospital_name.type"
              :value="hospital_name.type"
              :key="hospital_name.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="user_name_or_tel">
          <el-input v-model="search.user_name_or_tel" placeholder="服务对象姓名" clearable></el-input>
        </el-form-item>
        <el-form-item prop="nurse_name_or_tel">
          <el-input v-model="search.nurse_name_or_tel" placeholder="护理员姓名" clearable></el-input>
        </el-form-item>
        <el-form-item prop="town">
          <el-select v-model="search.town" placeholder="乡镇" clearable>
            <el-option v-for="area in villagesColumns" :label="area.type" :value="area.type" :key="area.type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="result">
          <el-select v-model="search.result" placeholder="住院状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="住院中" value="1"></el-option>
            <el-option label="已出院" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetForm('search')">重置</el-button>
          <el-button icon="el-icon-download" @click="handleExportOrder">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="info-card mt20">
      <div class="info-card-head">
        <span class="info-card-title">订单列表</span>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.6)"
        max-height="600"
        :header-cell-style="{ background: '#fafafa', color: '#303133' }"
        stripe
      >
        <el-table-column prop="start_at" label="入院日期" minWidth="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.start_at">{{ (scope.row.start_at * 1000) | formatDate('yyyy-MM-dd') }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="user_name" label="服务对象" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <div class="person-cell">
              <div class="person-name">{{ row.user_name || '—' }}</div>
              <div class="person-tel">{{ row.user_tel || '—' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="region" label="城市" minWidth="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.region">{{ scope.row.region }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="town" label="乡镇" minWidth="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.town">{{ scope.row.town }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="hospital_name" label="所在医院" minWidth="150" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.hospital_name">{{ scope.row.hospital_name }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column label="住院状态" minWidth="120" align="center">
          <template slot-scope="scope">
            <el-select
              v-if="rulesArr.includes('2')"
              v-model="scope.row.result"
              placeholder="住院状态"
              @change="changeStatus(scope.row.id, $event)"
            >
              <el-option label="住院中" :value="1"></el-option>
              <el-option label="已出院" :value="2"></el-option>
            </el-select>
            <el-tag v-else size="mini" :type="statusTagType(scope.row.result)" effect="plain">{{ scope.row.result == '1' ? '住院中' : '已出院' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column minWidth="180" label="出院时间" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.result === 2">{{ (scope.row.end_at * 1000) | formatDate('yyyy-MM-dd') }}</span>
            <span v-else class="empty-text">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="nurse_name" label="护理员" width="140" align="center">
          <template slot-scope="{ row }">
            <div class="person-cell">
              <div class="person-name">{{ row.nurse_name || '—' }}</div>
              <div class="person-tel">{{ row.nurse_tel || '—' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150" align="center">
          <template slot-scope="scope">
            <el-link v-if="rulesArr.includes('1')" type="primary" icon="el-icon-tickets" @click="handleDetails(scope.row.id)" class="op-link">详情</el-link>
            <el-link v-if="isAdmin || isDeleteBtn" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)" class="op-link">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          :current-page="page_number"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { apiArticleInfo, destituteLists, destituteDel, destituteLeave, destituteExport } from '@/api'
import { formatDate } from 'element-ui/lib/utils/date-util'
import { isAdmin } from '../../utils/util'
import { confirmDeleteOrder } from '@/utils/confirm-delete'

export default {
  data() {
    const { rules } = this.$store.state
    let rulesArr = rules.filter(i => Number(i.id) === 13)[0].child
    if (typeof rulesArr !== 'undefined') rulesArr = Object.values(rulesArr).map(mapData => mapData.id)
    const isDate = new Date()
    return {
      disabled: false,
      isAddNurse: false,
      fileList: [],
      rulesArr: rulesArr || [],
      thisDate: Date.parse(`${isDate.getFullYear()}/${isDate.getMonth() + 1}/${isDate.getDate()} 00:00:00`),
      search: {
        rangeDate: [],
        startDate: '',
        endDate: '',
        hospital_name: '',
        user_name_or_tel: '',
        nurse_name_or_tel: '',
        town: '', // 乡镇
        result: '1',
        region: ''
      },
      is_finance: 1,
      is_hospital: 1,
      tableLoading: false,
      page_size: 10,
      page_number: 1,
      total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      regionList: [],
      isDeleteBtn: false,
      villagesColumns: [
        { type: '全部', val: '' }
      ],
      hospitalColumns: [
        { type: '全部', val: '' }
      ],
      tableData: [],
      dialogVisible: false,
      imgUrl: '',
      editVisible: false,
      editForm: {
        id: '',
        nurse_name_or_tel: '',
        inServicePicture: '',
        brokerage: '',
        selfcareAbility: '',
        modificationTime: `${isDate.getFullYear()}/${isDate.getMonth() + 1}/${isDate.getDate()} ${isDate.getHours()}:${isDate.getMinutes()}`,
        nurse_tel: ''
      },
      editFormTitle: '',
      formLabelWidth: '153px'
    }
  },
  filters: {
    formatDate
  },
  computed: {
    isAdmin() {
      return isAdmin()
    }
  },
  mounted() {
    const tk_areastr = sessionStorage.getItem('tk_area')
    let tk_area = []
    console.log(tk_areastr)
    try {
      if (tk_areastr && tk_areastr !== '') {
        tk_area = JSON.parse(tk_areastr)
      }
    } catch (e) {
      console.log(e)
    }
    const regionList = [
      ...tk_area
    ]
    const rulesData = this.$store.state.rules.filter(i => i.url === '/orders_tk')[0]
    Object.values(rulesData.child).map(mapData => {
      if (mapData.name === '删除') this.isDeleteBtn = true
    })
    this.regionList = regionList
    this.search.region = regionList.length > 1 ? '' : regionList[0] || '无城市权限'
    this.init()
  },
  methods: {
    statusTagType(status) {
      const map = { 1: 'warning', 10: 'info', 20: 'info', 30: 'primary', 60: 'success', 50: 'danger', 41: 'danger', 40: 'warning', 2: 'info' }
      return map[status] || 'info'
    },
    init() {
      const is_finance = sessionStorage.getItem('is_finance')
      const is_hospital = sessionStorage.getItem('is_hospital')

      this.is_finance = is_finance
      this.is_hospital = is_hospital
      this.getList()
      this.getAreaList()
    },
    toYmd(v) {
      if (v == null || v === '') return ''
      if (typeof v === 'string') {
        const m = v.trim().match(/^(\d{4}-\d{2}-\d{2})/)
        if (m) return m[1]
      }
      const n = Number(v)
      const d = Number.isFinite(n) && n > 1e9
        ? new Date(n < 1e12 ? n * 1000 : n)
        : (v instanceof Date ? v : new Date(v))
      if (isNaN(d.getTime())) return ''
      const y = d.getFullYear()
      const m = d.getMonth() + 1
      const day = d.getDate()
      return `${y}-${m < 10 ? '0' : ''}${m}-${day < 10 ? '0' : ''}${day}`
    },
    // 与旧版 destitute_lists / destitute_export 一致：start_at、end_at 各传 yyyy-MM-dd
    buildFilterParams() {
      const params = {
        page_size: this.page_size,
        page_number: this.page_number,
        ...this.search
      }
      params.hospital_name = params.hospital_name === '全部' ? '' : params.hospital_name
      params.town = params.town === '全部' ? '' : params.town
      const rangeDate = params.rangeDate
      if (rangeDate) {
        params.start_at = this.toYmd(rangeDate[0])
        params.end_at = this.toYmd(rangeDate[1])
      } else {
        params.start_at = ''
        params.end_at = ''
      }
      delete params.rangeDate
      return params
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.page_number = 1
      this.search.hospital_name = ''
      this.search.town = ''
      this.getAreaList()
      this.getList()
    },
    handleExportOrder() {
      const params = {
        is_finance: this.is_finance,
        is_hospital: this.is_hospital,
        ...this.buildFilterParams()
      }
      destituteExport(params)
        .then(res => {
          const fileUrl = typeof res.data === 'string'
            ? res.data
            : (res.data && (res.data.url || res.data.file || res.data.path)) || ''
          if (fileUrl) {
            const elink = document.createElement('a')
            elink.href = fileUrl
            elink.download = '数据表格.xlsx'
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink)
          } else {
            this.$message.warning(res.msg || '没有数据可以导出')
          }
        })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.page_number = val
      this.getList()
    },
    searchData() {
      this.page_number = 1
      this.getList()
    },
    regionBlurFn() {
      this.search.hospital_name = ''
      this.search.town = ''
      this.getAreaList()
    },
    getList() {
      this.tableLoading = true
      const params = this.buildFilterParams()
      destituteLists(params)
        .then(res => {
          if (res.status) {
            this.tableData = res.data.list
            this.total = res.data.total
          } else {
            this.tableData = []
          }
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    getAreaList() {
      const params = {
        area: this.search.region
      }
      apiArticleInfo(params)
        .then(res => {
          if (res.status) {
            console.log(res.data)
            const { hospital = [], town = [] } = res.data

            this.hospitalColumns = [
              { type: '全部', val: '' },
              ...hospital.map(i => ({ type: i, val: i }))
            ]
            this.villagesColumns = [
              { type: '全部', val: '' },
              ...town.map(i => ({ type: i, val: i }))
            ]
          }
        })
    },
    changeStatus(id, status) {
      const params = { order_id: id, status }
      destituteLeave(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleDelete(id) {
      confirmDeleteOrder(this, '确定删除吗?')
        .then(() => {
          destituteDel({ order_id: id }).then(res => {
            if (res.status) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    handleDetails(_RowId) {
      this.$router.push('/orders_tk_details?id=' + _RowId)
    }
  }
}
</script>

<style lang="scss">
.el-upload--picture-card{
  width: 124px !important;
  height: 124px !important;
  line-height: 124px !important;
}
.el-upload-list--picture-card .el-upload-list__item{
  width: 124px !important;
  height: 124px !important;
}
</style>
<style lang="scss" scoped>
.order-list-page {
  padding: 16px 20px 30px;
}
.page-header {
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.mt20 { margin-top: 20px; }
.mt15 { margin-top: 15px; }
.info-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.info-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid #f2f6fc;
}
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  position: relative;
  padding-left: 10px;
}
.info-card-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 14px;
  background: #26a4b2;
  border-radius: 2px;
}
.empty-text { color: #c0c4cc; }
.person-cell { line-height: 1.6; }
.person-name { color: #303133; font-weight: 500; }
.person-tel { color: #909399; font-size: 13px; }
.op-link { margin-right: 12px; }
.block {
  text-align: center;
  margin-top: 20px;
}
</style>
